export default __webpack_public_path__ + "static/media/ks-motels-limited1.47af87dc.jpg";